import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { initializeAuth, getCurrentProfile } from '@/store/slices/authSlice';
import { fetchBranding } from '@/store/slices/brandingSlice';
import { AppDispatch } from '@/store';

export const useAuthInit = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const init = async () => {
      const result = await dispatch(initializeAuth());
      if (initializeAuth.fulfilled.match(result)) {
        // Sincronizar perfil
        dispatch(getCurrentProfile());
        // Fetch branding obligatorio para evitar datos stale
        dispatch(fetchBranding());
      }
    };
    
    init();
  }, [dispatch]);
};